import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { personaAccentColor, personaRoleLabel } from '../../domainTypes/ddr';

/** Enough of a DDR to name and colour its role. Structural rather than
 *  `Persona` because a transcript row carries an archetype off a message,
 *  with no persona record behind it. */
export type RoleChipSubject = {
    archetype: string;
    custom_role_title?: string | null;
    accent_color_hex?: string | null;
};

/**
 * A DDR's job title as an outlined pill, tinted with that DDR's own accent —
 * the same colour as its avatar ring. Used by the sidebar's DM rows, the room
 * panel's tab bar and the header above each message in the transcript.
 *
 * It resolves its own label rather than taking one, because taking one is how
 * the transcript grew a second archetype map (`humanizeArchetype`): it
 * rendered a lowercase "project manager" where every other surface said "PM",
 * and nothing pointed the two at each other. Give it the DDR and there is one
 * answer.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-role-chip',
    styleUrl: './role-chip.css',
    templateUrl: './role-chip.html',
})
export class RoleChip {
    readonly subject = input.required<RoleChipSubject>();

    /** A custom hire shows the role Alice hired it for, not "Custom role". */
    protected readonly label = computed(() => this.subject().custom_role_title || personaRoleLabel(this.subject().archetype));

    protected readonly accent = computed(() => personaAccentColor(this.subject()));
}
